import { DataNode } from 'antd/es/tree';

export enum PanelLocation {
  RIGHT_TOP = 'topRight',
  RIGHT = 'right',
  RIGHT_BOTTOM = 'bottomRight',
  BOTTOM = 'bottom',
  LEFT_BOTTOM = 'bottomLeft',
  LEFT = 'left',
  LEFT_TOP = 'topLeft',
  TOP = 'top',
}

export const PanelLocationDisplay = {
  [PanelLocation.RIGHT_TOP]: '右上',
  [PanelLocation.RIGHT]: '右',
  [PanelLocation.RIGHT_BOTTOM]: '右下',
  [PanelLocation.BOTTOM]: '下',
  [PanelLocation.LEFT_BOTTOM]: '左下',
  [PanelLocation.LEFT]: '左',
  [PanelLocation.LEFT_TOP]: '左上',
  [PanelLocation.TOP]: '上',
};

export enum Dimension {
  ORIGIN = 1,
  MINUTE = 2,
  MINUTE_15 = 3,
  HOUR = 4,
  DAY = 5,
  MONTH = 6,
  YEAR = 7,
}

export const DimensionDisplay = {
  [Dimension.ORIGIN]: '原始数据',
  [Dimension.MINUTE]: '1分钟',
  [Dimension.MINUTE_15]: '15分钟',
  [Dimension.HOUR]: '小时',
  [Dimension.DAY]: '日',
  [Dimension.MONTH]: '月',
  [Dimension.YEAR]: '年',
};

export enum HotSpotType {
  SCADA = 'scada',
  LINK = 'link',
  CIRCUIT = 'circuit',
}

export enum HotSpotOpenType {
  SELF = '_self',
  BLANK = '_blank',
}

export enum ControlType {
  YC = 1,
  ENUM_CONTROL_ENABLE = 2,
  ENUM_CONTROL_DISABLE = 3,
}

export enum ValveType {
  SHUTOFF = 1,
  SOLENOID = 2,
  CONTROL = 3,
}

export enum VideoOriginType {
  PLATFORM = 1,
  THIRD = 2,
}

export const ValveTypeDisplay = {
  [ValveType.SHUTOFF]: '开关阀',
  [ValveType.SOLENOID]: '电磁阀',
  [ValveType.CONTROL]: '调节阀',
};

export enum StationType {
  TAPWATER = 1,
  RECLIAIMED = 2,
  SEWAGE = 3,
}

export const StationTypeDisplay = {
  [StationType.TAPWATER]: '自来水站',
  [StationType.RECLIAIMED]: '中水站',
  [StationType.SEWAGE]: '污水站',
};

export const cumulantOptions = [
  {
    label: DimensionDisplay[Dimension.ORIGIN],
    value: Dimension.ORIGIN,
  },
  {
    label: DimensionDisplay[Dimension.MINUTE],
    value: Dimension.MINUTE,
  },
  {
    label: DimensionDisplay[Dimension.MINUTE_15],
    value: Dimension.MINUTE_15,
  },
  {
    label: DimensionDisplay[Dimension.HOUR],
    value: Dimension.HOUR,
  },
  {
    label: DimensionDisplay[Dimension.DAY],
    value: Dimension.DAY,
  },
  {
    label: DimensionDisplay[Dimension.MONTH],
    value: Dimension.MONTH,
  },
  {
    label: DimensionDisplay[Dimension.YEAR],
    value: Dimension.YEAR,
  },
];

export const instantaneousOptions = [
  {
    label: DimensionDisplay[Dimension.ORIGIN],
    value: Dimension.ORIGIN,
  },
  {
    label: DimensionDisplay[Dimension.MINUTE],
    value: Dimension.MINUTE,
  },
  {
    label: DimensionDisplay[Dimension.MINUTE_15],
    value: Dimension.MINUTE_15,
  },
  {
    label: DimensionDisplay[Dimension.HOUR],
    value: Dimension.HOUR,
  },
  {
    label: DimensionDisplay[Dimension.DAY],
    value: Dimension.DAY,
  },
];

export const hotSpotTypeDisplay: Record<HotSpotType, string> = {
  [HotSpotType.SCADA]: '组态',
  [HotSpotType.LINK]: '链接',
  [HotSpotType.CIRCUIT]: '回路',
};

export const filterTreeData = (data: DataNode[], key: string): DataNode[] => {
  const res: DataNode[] = [];
  data.forEach(item => {
    if ((item.title as string).includes(key)) {
      res.push(item);
    } else {
      if (item.children && item.children.length) {
        const newChild = filterTreeData(item.children, key);
        if (newChild.length) {
          const newData: DataNode = {
            ...item,
            children: newChild,
          };
          res.push(newData);
        }
      }
    }
  });
  return res;
};

export const filterDeviceList = (data: any[], key: string) => {
  const res: any[] = [];
  data.forEach(item => {
    if ((item.title as string).includes(key)) {
      res.push(item);
    }
  });
  return res;
};

export enum VideoAccessType {
  // 外高桥
  SWS = 1,
}

export enum StatisticalPeriod {
  THISMONTH = 1,
  LASTMONTH = 2,
  SEVENDAYS = 3,
  CUSTOM = 4,
}

export const StatisticalPeriodDisplay = {
  [StatisticalPeriod.THISMONTH]: '本月',
  [StatisticalPeriod.LASTMONTH]: '上月',
  [StatisticalPeriod.SEVENDAYS]: '近七日',
  [StatisticalPeriod.CUSTOM]: '自定义日期',
};

export enum InCludeToday {
  YES = 1,
  NO = 2,
}

export const InCludeTodayDisplay = {
  [InCludeToday.YES]: '是',
  [InCludeToday.NO]: '否',
};
